import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Alert from '@mui/material/Alert';
import { usePutMutation } from '../../hooks/useAuthenticatedMutation';
import useSnackbar from '../../hooks/useSnackbar';

const sanitizeLive = (raw) =>
    raw.replace(/\s+/g, '-').replace(/-+/g, '-');

const sanitizeFinal = (raw) =>
    sanitizeLive(raw).replace(/^-+|-+$/g, '');

const EditFieldDialog = ({ field, onClose }) => {
    const [name, setName] = useState(field.name);
    const [display, setDisplay] = useState(field.display);
    const putMutation = usePutMutation(`custom-fields/${field.id}`, 'custom-fields');
    const { showSnackbar } = useSnackbar();

    const handleUpdateField = (name, display) => {
        const onError = (error) => {
            const message = error.data.message || 'Could not update custom field';

            showSnackbar(message, 'error');
        };

        putMutation.mutate({ name: name, display: display }, { onSuccess: onClose, onError });
    };

    const handleChangeName = (e) => {
        setName(sanitizeLive(e.target.value));
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <DialogTitle>Edit Custom Field</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You are about to edit '{field.name}'.
                </DialogContentText>
                <Alert severity="info" sx={{ my: 1 }}>Custom field names cannot contain spaces. They will be replaced with hyphens (-)</Alert>
                <TextField
                    autoFocus
                    id="name"
                    label="Name"
                    type="text"
                    fullWidth
                    value={name}
                    onChange={handleChangeName}
                    margin="dense"
                />
                <FormControlLabel
                    control={(
                        <Switch
                            checked={display}
                            onChange={e => setDisplay(e.target.checked)}
                            name="enabled"
                        />
                    )}
                    label="Enabled"
                />
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        const finalField = sanitizeFinal(name);
                        handleUpdateField(finalField, display);
                    }}
                    loading={putMutation.isPending}
                    loadingPosition="start"
                >
                    OK
                </Button>
                <Button variant="outlined" onClick={onClose}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
};

export default EditFieldDialog;